<template>
  <v-tabs color="black" dark light slider-color="primary">
    <v-tab href="#tab-1">Admin</v-tab>
    <v-tab-item :value="'tab-1'">
      <v-card>
        <v-layout justify-center align-center>
          <v-flex xs12 sm10 md6>
            <h1
              style="
                padding-bottom: 30px;
                padding-top: 10px;
                text-align: center;
              "
            >
              Login
            </h1>
            <v-card-text class="text-xs-center" style="padding: 0 50px">
              <v-form>
                <v-text-field
                  prepend-inner-icon="person"
                  hide-details
                  name="login_owner"
                  label="Phone number / Email"
                  type="text"
                  v-model="phone_mail"
                  @keyup.enter="login()"
                  class="mb-3"
                ></v-text-field>
                <v-text-field
                  prepend-inner-icon="lock"
                  hide-details
                  name="password_owner"
                  label="Password"
                  type="password"
                  v-model="password"
                  @keyup.enter="login()"
                  class="mb-5"
                ></v-text-field>
              </v-form>
              <v-btn
                :loading="logingIn"
                :disabled="logingIn"
                block
                large
                round
                color="primary"
                class="black--text mb-3"
                @click="login()"
                >login</v-btn
              >
              <v-layout row justify-center class="mb-3"></v-layout>
            </v-card-text>
          </v-flex>
          <v-flex xs12 sm8 md6 class="hidden-sm-and-down">
            <v-img :src="image_owner" aspect-ratio="0.7"></v-img>
          </v-flex>
        </v-layout>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    drawer: null,
    phone_mail: "",
    password: "",
    staff_owner_tel: "",
    staff_username: "",
    staff_password: "",
    logingIn: false,
    image_owner: require("../../assets/login-owner.jpg"),
    image_staff: require("../../assets/login-staff.jpg"),
  }),
  computed: {
    ...mapState({
      role: (state) => state.role,
    }),
  },
  props: {
    source: String,
  },
  methods: {
    async login() {
      this.logingIn = true;
      let result = await this.$store.dispatch("login", {
        user_login: this.phone_mail,
        user_password: this.password,
      });
      if (result == true) return;
      this.logingIn = false;
    },
  },
};
</script>

<style scoped>
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #ffd806;
  border-color: #dee2e6 #dee2e6 transparent;
}

.nav-item a {
  color: #333;
}

#auth-container {
  margin-top: 50px;
}

.tab-content {
  padding: 20px;
  border: 1px solid #dee2e6;
  border-top: none;
  background-color: #ffd806;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 2.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: none;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-weserve {
  background-color: #333;
  color: white;
  line-height: 2.5;
  border-radius: 0;
}

.mt10 {
  margin-top: 10px;
}
</style>
